module.exports = __webpack_public_path__ + "static/media/bg.f02c37fc.jpg";